import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import ic_close_red from "../../assets/images/ic_close_red.svg";
import ic_add_plus from "../../assets/images/ic_add_plus.svg";
import ic_arrow_right_white from "../../assets/images/ic_right_arrow_circle.svg";
import animal_img from "../../assets/images/animal_img.png";
import ic_cross_green from "../../assets/images/ic_cross_green.svg";

import { Link } from "react-router-dom";

const MyAnimalProfileComp = () => {
  const [rows, setRows] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const addNewRow = () => {
    const newRow = {
      index: currentIndex
      // other row data properties...
    };

    setRows([...rows, newRow]);
    setCurrentIndex(currentIndex + 1);
  };

  return (
    <div>
      <div className="right-section">
        <section className="wrapper-cards ">
          <h5>My Animal Profile</h5>

          <dov className="row">
            <div className="col-md-6 form-group">
              <Form.Group className="">
                <Form.Label>Animal Name</Form.Label>
                <Form.Control type="text" placeholder="Enter animal name" />
              </Form.Group>
            </div>
            <div className="col-md-6 form-group">
              <Form.Group className="">
                <Form.Label>Type of Animal</Form.Label>
                <Form.Select aria-label="Work / Home / Other">
                  <option value="1">Dog</option>
                  <option value="2">Cat</option>
                  <option value="3">Pig</option>
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-6 form-group">
              <Form.Group className="">
                <Form.Label>Animal Age</Form.Label>
                <Form.Control type="text" placeholder="Enter Animal Age..." />
              </Form.Group>
            </div>
            <div className="col-md-6 form-group">
              <Form.Group className="">
                <Form.Label>Animal Photographs</Form.Label>
                <Form.Control type="text" placeholder="Select Animal Photos" />
              </Form.Group>
            </div>
            <div className="col-md-6 form-group">
              <Form.Label>Preview</Form.Label>
              <div className="animal-img-wrapper">
                <div className="img">
                  <img src={animal_img} alt="" className="animal" />
                  <button>
                    <img src={ic_cross_green} alt="" className="cross-icon" />
                  </button>
                </div>
                <div className="img">
                  <img src={animal_img} alt="" className="animal" />
                  <button>
                    <img src={ic_cross_green} alt="" className="cross-icon" />
                  </button>
                </div>
                <div className="img">
                  <img src={animal_img} alt="" className="animal" />
                  <button>
                    <img src={ic_cross_green} alt="" className="cross-icon" />
                  </button>
                </div>
              </div>
            </div>
          </dov>
        </section>

        {rows.map((row) => (
          <section className="wrapper-cards mt-3">
            <div className="heading-close-btn">
              <h5>My Animal Profile</h5>
              <Link>
                <img src={ic_close_red} alt="" />
              </Link>
            </div>
            <dov className="row">
              <div className="col-md-6 form-group">
                <Form.Group className="">
                  <Form.Label>Animal Name</Form.Label>
                  <Form.Control type="text" placeholder="Enter animal name" />
                </Form.Group>
              </div>
              <div className="col-md-6 form-group">
                <Form.Group className="">
                  <Form.Label>Type of Animal</Form.Label>
                  <Form.Select aria-label="Work / Home / Other">
                    <option value="1">Dog</option>
                    <option value="2">Cat</option>
                    <option value="3">Pig</option>
                  </Form.Select>
                </Form.Group>
              </div>
              <div className="col-md-6 form-group">
                <Form.Group className="">
                  <Form.Label>Animal Age</Form.Label>
                  <Form.Control type="text" placeholder="Enter Animal Age..." />
                </Form.Group>
              </div>
              <div className="col-md-6 form-group">
                <Form.Group className="">
                  <Form.Label>Animal Photographs</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Select Animal Photos"
                  />
                </Form.Group>
              </div>
              <div className="col-md-6 form-group">
                <Form.Label>Preview</Form.Label>
                <div className="animal-img-wrapper">
                  <div className="img">
                    <img src={animal_img} alt="" className="animal" />
                    <button>
                      <img src={ic_cross_green} alt="" className="cross-icon" />
                    </button>
                  </div>
                  <div className="img">
                    <img src={animal_img} alt="" className="animal" />
                    <button>
                      <img src={ic_cross_green} alt="" className="cross-icon" />
                    </button>
                  </div>
                  <div className="img">
                    <img src={animal_img} alt="" className="animal" />
                    <button>
                      <img src={ic_cross_green} alt="" className="cross-icon" />
                    </button>
                  </div>
                </div>
              </div>
            </dov>
          </section>
        ))}

        <div className="buttons-wrapper-main">
          <div className="add-btn-wrapper mt-3">
            <button onClick={addNewRow}>
              <img src={ic_add_plus} alt="" />
              Add Animal
            </button>
          </div>

          <div className="submit-btn-group mt-3">
            <button className="blank-btn">Cancel</button>
            <button className="filled-btn">
              Update
              <img src={ic_arrow_right_white} alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAnimalProfileComp;
